import { inject, Injectable } from '@angular/core';
import { BookingCategoryType } from '@com-delta-idp/mnx-sitewide-header-ui';
import { HeaderStateService } from './header-state.service';

@Injectable({ providedIn: 'root' })
export class BookingTabService {
  private readonly headerState = inject(HeaderStateService);

  private getIndexMap(): Record<string, number> {
    return {
      [this.headerState.bookingCategoryType.flights]: 0,
      [this.headerState.bookingCategoryType.stays]: 1,
      [this.headerState.bookingCategoryType.cars]: 2,
      [this.headerState.bookingCategoryType.vacations]: 3
    };
  }

  setBookingTab(event: BookingCategoryType): void {
    this.headerState.setBookingTabValue(event);
    const indexMap = this.getIndexMap();
    this.headerState.bookingCategoryIndex = indexMap[event] ?? 0;
  }
}
